import React from 'react'
import { getFilteredResultsFromContainers } from '../../calculators/calculator-result-utility'
import { calculateEer } from '../../calculators/eer/eer-calculator'
import { CalculatedVersion } from '../../calculators/use-calculator'
import { PurchasedEnergyResultSubCategory } from '../../provider/result-categories'
import { formatEer } from '../../util/formatters'
import { ResultsTableRow } from '../common/ResultsTableRow'

type Props = {
  title: string
  versions: CalculatedVersion[]
  purchasedEnergySubCategories: PurchasedEnergyResultSubCategory[]
  increasePrecision?: boolean
}

export function EerResultsTableRow(props: Props): React.ReactElement {
  const { title, versions, purchasedEnergySubCategories, increasePrecision } =
    props

  const getEer = ({ energyCalculator, totalArea: area }: CalculatedVersion) => {
    const containers = energyCalculator.getAllContainers()
    const energyBus = energyCalculator.findEnergyBus()

    const totalEnergies = purchasedEnergySubCategories.map((subCategory) => ({
      energyType: subCategory.purchasedEnergyType,
      total: getFilteredResultsFromContainers(
        subCategory,
        containers,
        energyBus,
      ).total,
    }))

    return calculateEer(totalEnergies, area)
  }

  const eersByVersion = versions.map((version) => ({
    id: version.id,
    eer: getEer(version),
  }))

  const allEersAreZero = eersByVersion.every(
    (version) => Math.round(version.eer) === 0,
  )
  if (allEersAreZero) {
    return <></>
  }

  return (
    <ResultsTableRow
      title={title}
      highlight={!increasePrecision}
      values={eersByVersion.map((version) => version.eer)}
      formatter={formatEer}
    />
  )
}
